import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = {
  class: "milestone-left d-flex flex-row position-relative",
  style: { width: '75px' }
}
const _hoisted_3 = {
  class: "text-caption ms-1",
  style: {"width":"50px"}
}
const _hoisted_4 = {
  key: 0,
  class: "white-space-pre"
}
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = { class: "justify-space-between position-relative" }
const _hoisted_7 = { class: "d-flex justify-content-center" }
const _hoisted_8 = { class: "dot-line" }
const _hoisted_9 = {
  key: 0,
  class: "d-flex justify-content-center position-absolute",
  style: {"bottom":"1px"}
}
const _hoisted_10 = {
  class: "ps-2 pb-4",
  style: { width: 'calc(100% - 75px)' }
}
const _hoisted_11 = ["data-bs-target", "aria-controls"]
const _hoisted_12 = { class: "d-flex flex-wrap align-center text-body-2" }
const _hoisted_13 = { class: "d-flex align-center text-gray text-body-2" }
const _hoisted_14 = ["id"]
const _hoisted_15 = { class: "d-flex" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "ps-2 d-flex align-center text-gray text-caption" }
const _hoisted_18 = { class: "d-flex" }
const _hoisted_19 = {
  key: 0,
  class: "ms-6"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "d-flex ps-2 align-center text-gray text-caption" }

import { ref, onMounted } from 'vue'
import { Milestone } from '../../../api/v2/models/user_goal'
import { useGoalMilestone } from './useGoalMilestone'
import MilestoneTeacherCheck from './MilestoneTeacherCheck.vue'

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'GoalMilestoneMobile',
  props: {
    milestone: {},
    isFirst: { type: Boolean, default: false },
    isLast: { type: Boolean, default: false }
  },
  emits: ["to-exam", "to-course"],
  setup(__props: any, { emit: __emit }) {

const props = __props

// Emits
const emit = __emit

// Refs
const milestonToggle = ref<HTMLElement | null>(null)

// Use composable
const { mobile, progressPercent, dateFormat } = useGoalMilestone(props)

// Functions
function handleToExam(examId: string) {
  emit('to-exam', examId)
}

function handleToCourse(courseId: string) {
  emit('to-course', courseId)
}

// Lifecycle
onMounted(() => {
  if (!props.milestone.completedAt && milestonToggle.value) {
    milestonToggle.value.click()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_img = _resolveComponent("v-img")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (__props.isFirst)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, "スタート"))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(dateFormat)(__props.milestone.targetDate)), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", {
            class: _normalizeClass(["dot-circle d-flex justify-content-center align-center", _unref(progressPercent) > 0 ? 'dot-blue' : 'dot-gray'])
          }, [
            (__props.milestone.completedAt)
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 0,
                  color: "white",
                  small: ""
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("mdi-check", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */)
        ]),
        _createElementVNode("div", {
          class: "d-flex justify-content-center w-full h-full position-absolute",
          style: _normalizeStyle({ height: __props.isLast ? 'calc(100% - 30px)' : '100%' })
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "dot-line-blue w-full",
              style: _normalizeStyle({ height: `${_unref(progressPercent)}%` })
            }, null, 4 /* STYLE */)
          ])
        ], 4 /* STYLE */),
        (__props.isLast)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("span", {
                class: _normalizeClass(["dot-circle last-dot d-flex justify-content-center align-center", _unref(progressPercent) == 100 ? 'dot-blue' : 'dot-gray'])
              }, null, 2 /* CLASS */)
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", {
        ref_key: "milestonToggle",
        ref: milestonToggle,
        class: "d-flex justify-space-between cursor-pointer",
        "data-bs-toggle": "collapse",
        "data-bs-target": `#collapse${__props.milestone.id}`,
        "aria-expanded": "false",
        "aria-controls": `collapse${__props.milestone.id}`
      }, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", null, _toDisplayString(__props.milestone.name), 1 /* TEXT */),
          _createVNode(MilestoneTeacherCheck, {
            check: __props.milestone.teacherCheck,
            part: "badge"
          }, null, 8 /* PROPS */, ["check"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createTextVNode(_toDisplayString(_unref(progressPercent)) + "% ", 1 /* TEXT */),
          _createVNode(_component_v_icon, {
            class: "ms-2",
            small: ""
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("mdi-arrow-down-drop-circle-outline", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          })
        ])
      ], 8 /* PROPS */, _hoisted_11),
      _createVNode(_component_v_divider),
      _createVNode(MilestoneTeacherCheck, {
        check: __props.milestone.teacherCheck,
        part: "comment"
      }, null, 8 /* PROPS */, ["check"]),
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          class: "collapse",
          id: `collapse${__props.milestone.id}`
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.milestone.enrollments, (enrollment) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "d-flex justify-space-between mt-2",
              key: enrollment.id
            }, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_v_icon, {
                  color: "blue",
                  small: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(enrollment.progressPercent == 100 ? 'mdi-checkbox-marked-outline' : 'mdi-checkbox-blank-outline'), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */),
                _createElementVNode("div", {
                  class: "ms-2 d-flex align-center text-blue2 cursor-pointer text-caption",
                  onClick: ($event: any) => (handleToCourse(enrollment.course.id.toString()))
                }, _toDisplayString(enrollment.course.name), 9 /* TEXT, PROPS */, _hoisted_16)
              ]),
              _createElementVNode("div", _hoisted_17, _toDisplayString(enrollment.progressPercent) + "%", 1 /* TEXT */)
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.milestone.exams, (exam) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "d-flex justify-space-between mt-2",
              key: exam.id
            }, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_v_icon, {
                  color: "blue",
                  small: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(exam.hasUserExam && exam.userExamScore != null
                ? 'mdi-checkbox-marked-outline'
                : 'mdi-checkbox-blank-outline'), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */),
                (!_unref(mobile))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createVNode(_component_v_img, {
                        src: exam.image.url,
                        "max-height": "50",
                        "min-height": "50",
                        "max-width": "60",
                        "min-width": "60",
                        contain: ""
                      }, null, 8 /* PROPS */, ["src"])
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", {
                  class: "ms-2 d-flex align-center text-blue2 cursor-pointer text-caption",
                  onClick: ($event: any) => (handleToExam(exam.id.toString()))
                }, _toDisplayString(exam.name), 9 /* TEXT, PROPS */, _hoisted_20)
              ]),
              _createElementVNode("div", _hoisted_21, [
                (!exam.hasUserExam)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" テスト待ち ")
                    ], 64 /* STABLE_FRAGMENT */))
                  : (exam.userExamScore !== null && !exam.hideResult)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(exam.userExamScore) + "点 ", 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : (exam.userExamScore !== null && exam.hideResult)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(" 結果公開待ち ")
                        ], 64 /* STABLE_FRAGMENT */))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createTextVNode(" テスト中 ")
                        ], 64 /* STABLE_FRAGMENT */))
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ], 8 /* PROPS */, _hoisted_14)
      ])
    ])
  ]))
}
}

})